import { Placeholder, useSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { TabsContent } from '@ahc-digital/component-library';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { TAB_CONTENT_CONTAINER_VALUE } from 'src/shared/static';
import { N08TabProps } from './N08Tabs.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: N08TabProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return isEditing ? (
    <div className="component-content">
      <Text field={props?.fields?.TabTitle} />
      <Placeholder name={TAB_CONTENT_CONTAINER_VALUE} rendering={props?.rendering} />
    </div>
  ) : (
    <TabsContent value={props?.rendering?.uid || ''} data-component={marketingRenderingName}>
      <Placeholder name={TAB_CONTENT_CONTAINER_VALUE} rendering={props?.rendering} />
    </TabsContent>
  );
};
